import { Saga } from "redux-saga";
import { all, call, spawn } from "redux-saga/effects";
import claimSaga from "./claim/saga";

export default function* rootSaga() {
  const sagas: Saga[] = [claimSaga];

  yield all(
    sagas?.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.error("Saga caught exception:", e);
          }
        }
      })
    )
  );
}
